export class BasemapMapGlobalSettings {
  private static enableAnimations = true;

  public static setEnableAnimations(enableAnimations: boolean): void {
    this.enableAnimations = enableAnimations;
  }

  public static getEnableAnimations(): boolean {
    return this.enableAnimations;
  }
}
